import { useRegisterSW } from 'virtual:pwa-register/react';
import { useBranding } from '../../context/BrandingContext';

export function ReloadPrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  const { branding } = useBranding();

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  if (!offlineReady && !needRefresh) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 md:left-auto md:right-8 md:bottom-8 z-[200]">
      <div className="bg-white rounded-2xl shadow-2xl border border-foret-100 p-4 animate-in slide-in-from-bottom duration-300 max-w-sm">
        <div className="flex gap-4 items-start">
          <div className="w-10 h-10 rounded-full bg-foret-50 flex items-center justify-center flex-shrink-0 text-foret-600">
            <i className={needRefresh ? "ri-refresh-line text-xl" : "ri-checkbox-circle-line text-xl"} />
          </div>
          <div className="flex-1">
            <p className="text-sm font-black text-gray-900 leading-tight">
              {needRefresh ? "Mise à jour disponible !" : "Prêt pour le mode hors-ligne"}
            </p>
            <p className="text-xs text-gray-500 mt-1">
              {needRefresh 
                ? `Une nouvelle version de ${branding.nom} est disponible.` 
                : "L'application fonctionne maintenant sans connexion internet."}
            </p>
            <div className="mt-4 flex gap-2">
              {needRefresh && (
                <button
                  onClick={() => updateServiceWorker(true)}
                  className="bg-foret-600 text-white px-4 py-2 rounded-xl text-xs font-black shadow-lg shadow-foret-600/20 cursor-pointer"
                >
                  METTRE À JOUR
                </button>
              )}
              <button
                onClick={close}
                className="bg-gray-100 text-gray-600 px-4 py-2 rounded-xl text-xs font-black cursor-pointer hover:bg-gray-200"
              >
                FERMER
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
